import React, { useCallback, useState } from "react";
import { Button, SelectIcon } from "evergreen-ui";
import POMatchDialog from "../POMatchDialog";

const MatchPOButton = ({ invoiceID, onSuccess }) => {
  const [dialogIsShown, setDialogIsShown] = useState(false);

  const hideDialog = useCallback(() => {
    setDialogIsShown(false);
  }, []);

  const handleClick = useCallback(() => {
    setDialogIsShown(true);
  }, []);

  const handleConfirm = useCallback(
    (po) => {
      setDialogIsShown(false);
      onSuccess(po);
    },
    [onSuccess]
  );

  return (
    <>
      <Button iconBefore={SelectIcon} onClick={handleClick}>
        Match Invoice to PO
      </Button>
      {dialogIsShown ? (
        <POMatchDialog
          invoiceID={invoiceID}
          isShown={dialogIsShown}
          onCancel={hideDialog}
          onClose={hideDialog}
          onConfirm={handleConfirm}
        />
      ) : null}
    </>
  );
};

export default MatchPOButton;
